import { School } from '../schools/model/school.model';
import { FormulaType, ValueType } from '../shared/model/period-discount.model';

export class SalaryModifier {
    constructor(
        public id?: string,
        public description?: string,
        public variable?: string,
        public school?: School,
        public valueType?: ValueType,
        public formulaType?: FormulaType,
        public amount?: number,
        public active?: boolean,
        public deleted?: boolean,
        public formula?: string,
        public modifierType?: ModifierType,
        public variables?: ModifierVariable[],
        public priority?: number,
        public applyToAll?: boolean,
        public fromDate?: Date,
        public toDate?: Date,
        public applyResults?: SalaryModifierApplyTo[],
        public integrationCode?: string
    ) {
        this.id = id ? id : null;
        this.description = description ? description : '';
        this.variable = variable ? variable : '';
        this.valueType = valueType ? valueType : ValueType.FIXED_VALUE;
        this.formulaType = formulaType ? formulaType : FormulaType.DEFAULT;
        this.school = school ? school : new School();
        this.amount = amount ? amount : 0;
        this.active = active ? active : true;
        this.deleted = deleted ? deleted : false;
        this.formula = formula ? formula : '';
        this.modifierType = modifierType ? modifierType : ModifierType.ADDITION;
        this.variables = variables ? variables : [];
        this.priority = priority ? priority : 0;
        this.applyToAll = applyToAll ? applyToAll : false;
        this.applyResults = applyResults ? applyResults : [];
        this.fromDate = fromDate ? fromDate : null;
        this.toDate = toDate ? toDate : null;
        this.integrationCode = integrationCode ? integrationCode : '';
    }
}

export class SalaryModifierApplyTo {
    constructor(
        public salaryParameterId?: string,
        public errorMessage?: string
    ) {
        this.salaryParameterId = salaryParameterId ? salaryParameterId : '';
        this.errorMessage = errorMessage ? errorMessage : '';
    }
}
export class ModifierVariable {
    constructor(
        public name?: string,
        public variable?: string,
        public type?: ModifierVariableType,
        public list?: ModifierValueElement[]
    ) {
        this.name = name ? name : '';
        this.variable = variable ? variable : '';
        this.type = type ? type : ModifierVariableType.DECIMAL;
        this.list = list ? list : [];
    }
}
export class ModifierValueElement {
    constructor(
        public name?: string,
        public value?: number,
        public key?: string
    ) {
        this.name = name ? name : '';
        this.key = key ? key : '';
        this.value = value ? value : 0;
    }
}
export class EmployeeSalaryModifier {
    constructor(
        public type?: SalaryModifier,
        public values?: ModifierValueElement[],
        public fromDate?: Date,
        public toDate?: Date,
        public active?: boolean,
        public isUnfinishedModifier?: boolean
    ) {
        this.type = type ? type : new SalaryModifier();
        this.values = values ? values : [];
        this.fromDate = fromDate ? fromDate : null;
        this.toDate = toDate ? toDate : null;
        this.active = active ? active : true;
    }
}
export class SalaryModifierSearch {
    constructor(
        public description?: string,
        public variable?: string,
        public modifierTypes?: ModifierType[],
        public schoolId?: string
    ) {}
}
export class FormulaVariable {
    constructor(
        public formula?: string,
        public variables?: ModifierVariable[],
        public schoolId?: string
    ) {
        this.formula = formula ? formula : '';
        this.variables = variables ? variables : [];
        this.schoolId = schoolId ? schoolId : '';
    }
}

export class ModifierVariableFormula {
    constructor(
        public key?: string,
        public description?: string
    ) {
        this.key = key ? key : '';
        this.description = description ? description : '';
    }
}

export enum ModifierType {
    ADDITION = 'ADDITION',
    SUBTRACTION = 'SUBTRACTION',
    EMPLOYEE_TAX = 'EMPLOYEE_TAX',
    EMPLOYER_TAX = 'EMPLOYER_TAX',
    TAX_MODIFIER = 'TAX_MODIFIER',
    BASE_SALARY_MODIFIER = 'BASE_SALARY_MODIFIER',
}
export enum ModifierVariableType {
    INTEGER = 'INTEGER',
    DECIMAL = 'DECIMAL',
    LIST = 'LIST',
}
